import { render, staticRenderFns } from "./ExtendedWarrantyTab.vue?vue&type=template&id=08d58167"
import script from "./ExtendedWarrantyTab.vue?vue&type=script&lang=js"
export * from "./ExtendedWarrantyTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports